import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { fetchEntitlements } from '@api/entitlements';
import type { EntitlementResponse } from '@api/types/entitlements';

const ENTITLEMENTS_QUERY_KEY = ['entitlements'] as const;

export interface UseEntitlementsResult {
  entitlements: EntitlementResponse[];
  openGates: string[];
  isLoading: boolean;
  isError: boolean;
  isGateOpen: (gate: string) => boolean;
}

export function useEntitlements(enabled = true): UseEntitlementsResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: ENTITLEMENTS_QUERY_KEY,
    queryFn: fetchEntitlements,
    staleTime: 60_000,
    enabled,
  });

  const openGates = useMemo(() => data?.openGates ?? [], [data]);

  const isGateOpen = useCallback(
    (gate: string) => openGates.includes(gate),
    [openGates],
  );

  return {
    entitlements: data?.skills ?? [],
    openGates,
    isLoading,
    isError,
    isGateOpen,
  };
}

export default useEntitlements;
